import { render, staticRenderFns } from "./LayoutView.vue?vue&type=template&id=5d637434&scoped=true"
import script from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LayoutView.vue?vue&type=style&index=0&id=5d637434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d637434",
  null
  
)

export default component.exports